module.exports = __webpack_public_path__ + "img/card-h.c0baad60.png";